export const COUNTRY_CODE = 'gb';

// This only checks if it is native stripe or medusa payments for card payments, it ignores the other stripe-based providers
export const isStripeLike = (providerId?: string) => {
  return (
    providerId?.startsWith('pp_stripe_') || providerId?.startsWith('pp_medusa-')
  );
};

export const isStripe = isStripeLike;

export const isManual = (providerId?: string) => {
  return providerId?.startsWith('pp_system_default');
};
